import styled from 'styled-components'
import globals from '../globals'
import { lighten, darken } from 'polished'

const { padding, lineHeight } = globals.inputs;

export const Button = styled.button`
  border:0;
  border-radius: 23px;
  cursor: pointer;
  color: ${props => props.type === "primary" || props.type === "ghost" ? 'white' : globals.colors.darkblue};
  background: ${props => props.type === 'ghost' ? 'transparent' : globals.colors.lightblue};
  box-shadow: ${props => props.type === 'ghost' ? 'inset 0 0 0 2px white' : 'none'};
  line-height: ${props => lineHeight[props.size]};
  padding: ${props => padding[props.size]};
  transition: all .2s;
  font-weight:bold;
  
  &:hover {
    background: ${props => props.type === 'ghost' ? 'transparent' : lighten(0.1, globals.colors.lightblue)};
    box-shadow: ${props => props.type === 'ghost' ? `inset 0 0 0 2px ${globals.colors.darkblue}` : 'none'};
    color: ${props => props.type === "primary" || props.type === "ghost" ? globals.colors.darkblue : 'white'};
  }

  &:focus {
    outline:none;
    box-shadow: ${props => props.type === 'ghost' ? `inset 0 0 0 2px white, 0 0 0 3px rgba(255,255,255,0.3)` : 'none'}
    /* outline-color: ${globals.colors.lightblue}; */
  }

  &:active {
    outline:none;
    background: ${props => props.type === 'ghost' ? 'transparent' : darken(0.1, globals.colors.lightblue)};
  }
`